import {
  ENABLE_AMENDMENT_V2_JOURNEY,
  ENABLE_ANNUAL_REPORT_V2_JOURNEY,
  ENABLE_BLR_SPECIFIC_CONTENT,
  ENABLE_SCORP_BUNDLE_V1,
  RELEASE_SQUARESPACE_DOMAINS_RESELLER
} from '#client/constants/experimentsFlags';

/**
 * Mapping of product IDs to their corresponding experiment flags.
 * These flags are used during the deprecation of zenreg,
 * as part of the gradual transition to new journey flows.
 * @type {object<string, string>}
 */
export const PRODUCT_FLAG_MAPPING = {
  amendment: ENABLE_AMENDMENT_V2_JOURNEY,
  'annual-report': ENABLE_ANNUAL_REPORT_V2_JOURNEY,
  'business-licenses': ENABLE_BLR_SPECIFIC_CONTENT,
  'domain-name-reg': RELEASE_SQUARESPACE_DOMAINS_RESELLER,
  's-corp-bundle': ENABLE_SCORP_BUNDLE_V1
};
